import styled from '@emotion/styled'
import FormInputGroup from '../../../UI/FormInputGroup'

export const HeadingText = styled.p`
  font-size: 16px;
  color: #3e3f42;
`

export const HeadingSubText = styled.p`
  color: #555858;
  font-size: 14px;
  margin-top: 6px;
`

export const LeftContainer = styled.div`
  width: 35%;
  margin: 30px 0 30px 30px;
`

export const RightContainer = styled.div`
  width: 65%;
  margin: 30px 0;
  padding-right: 30px;
`

export const ContainerWrapper = styled.div`
  display: flex;
`

export const DriverInstructionTextArea = styled.textarea`
  width: calc(100% - 46px);
  height: 144px;
  padding: 14px;
  border: 1px solid #d8dce6;
  margin-top: 5px;
  resize: none;
  border-radius: 4px;
  background: #eaedf380;
  box-sizing: border-box;
`

export const LabelText = styled.p`
  color: #555858;
  font-size: 12px;
`

export const TextFieldContainer = styled.div`
  & label,
  span {
    text-transform: none;
    color: #555858;
    font-weight: normal;
  }
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ErrorMessageSpan = styled.span`
  position: absolute;
  color: #e6492d;
  font-size: 0.75rem;
`

export const HalfWidthGroup = styled(FormInputGroup)`
  width: 45%;
  padding-right: 30px;
`

export const InputContainer = styled(FormInputGroup)`
  display: flex;
  flex-direction: row;
`

export const SecondRowContainter = styled(InputContainer)`
  margin-top: 30px;
`
